import React from 'react';
import { useSelector } from 'react-redux';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import { capitalize } from 'lodash';
import CountryDisplay from 'components/CountryDisplay';
import InfoItem from '../InfoItem';
import { InfoGroup } from '../../styled';

const PersonalInformation = () => {
  const { planholder } = useSelector((state) => state.nomadInsurance.application);
  const { data: userProfile } = useSelector((state) => state.app.profile);

  const formattedDateOfBirth = planholder?.dateOfBirth
    ? format(parse(planholder.dateOfBirth, 'yyyy-MM-dd', new Date()), 'MMMM d, yyyy')
    : '-';

  return (
    <InfoGroup>
      <InfoItem heading="Full name">
        {`${planholder?.firstName} ${planholder?.lastName}`}
      </InfoItem>
      <InfoItem heading="Date of birth">{formattedDateOfBirth}</InfoItem>
      <InfoItem heading="Gender">
        {planholder?.gender ? capitalize(planholder?.gender) : '-'}
      </InfoItem>
      <InfoItem heading="Citizenship">
        <CountryDisplay countryCode={planholder?.citizenship} variant="dark" />
      </InfoItem>
      <InfoItem heading="Home country">
        <CountryDisplay countryCode={userProfile?.homeCountry} variant="dark" />
      </InfoItem>
    </InfoGroup>
  );
};

export default PersonalInformation;
